import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useCommandState, CommandEmpty } from 'cmdk';
import { forwardRef } from 'react';
import { searchEmpty } from '../../../shared/styles/searchEmpty.vanilla.mjs';

const SingleSelectSearchEmpty = forwardRef(({ children, className: classNameFromProps, ...props }, forwardedRef) => {
  const searchKeyword = useCommandState((state) => state.search);
  const className = classNames(searchEmpty, classNameFromProps);
  return /* @__PURE__ */ jsx(
    CommandEmpty,
    {
      "data-scope": "single-select",
      "data-part": "search-empty",
      className,
      ref: forwardedRef,
      ...props,
      children: typeof children === "function" ? children(searchKeyword) : children
    }
  );
});

export { SingleSelectSearchEmpty as SelectSearchEmpty };
//# sourceMappingURL=SearchEmpty.mjs.map
